import { useSpreadSheetData } from '../SpreadSheetDataProvider'
import { setIsDragging, setSelection, setSelectionType } from '../SpreadSheetDataProvider/actions'
import BaseCell from './BaseCell'
import HeaderFilter from './HeaderFilter'
import HeaderSorter from './HeaderSorter'
import ResizeableHandle from './ResizeableHandle'
import { selectionTypes } from '../helpers'
import './HeaderCell.scss'

HeaderCell = ({
  columnIndex,
  rowIndex,
  style
}) ->

  [{
    columns,
    isDragging,
    selection,
    selectionType
  }, dispatch] = useSpreadSheetData()

  r = -1
  c = columnIndex

  column = columns[c]
  isLastCol = columnIndex is columns.length - 1

  return <span /> unless column

  selectSingleCol = ->
    dispatch(setSelectionType(selectionTypes.MULTI_COL))
    dispatch(setSelection([columnIndex, columnIndex]))

  includeColInSelection = ->
    dispatch(setSelectionType(selectionTypes.MULTI_COL))
    dispatch(setSelection([selection[0], columnIndex]))

  <BaseCell
    rowIndex={r}
    colIndex={c}
    style={style}
    onMouseDown={(e) ->
      return if e.button is 2
      if e.shiftKey
        includeColInSelection()
      else
        selectSingleCol()
    }
    onMouseMove={
      if isDragging and (selectionType is selectionTypes.MULTI_COL)
        includeColInSelection
    }
  >
    <HeaderSorter column={column} />
    <HeaderFilter column={column} isLastCol={isLastCol} />
    <ResizeableHandle c={c} />
  </BaseCell>

export default React.memo(HeaderCell)
